import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ServerUsers } from '../resources/ServerUsers';
import { IServerUser } from '../ServerApi/types/IServerUser';
import { IUserActionResult } from '../ServerApi/types/IUserActionResult';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { UserActionNotification, UserActionNotificationParams } from './UserActionNotification';

export class DeleteUsersFromServerAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'UserActionNotification',
                           'ServerUsers'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private userActionNotification: UserActionNotification,
    private ServerUsers: ServerUsers) { }

  public showDeleteUsersFromServerDialog(
    serverUsers: Set<IServerUser>,
    context: IActionContext): ng.IPromise<any> {

    const dialogBody = this.$translate.instant('confirmDeleteUsers', {
      USER_NAME: L10n.elideIfLong(serverUsers.first().displayName),
      USER_COUNT: serverUsers.size()
    }, L10n.Interpolations.Count);

    const dialogInstance = this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: dialogBody,
      actionName: this.$translate.instant('confirmDeleteButton', {
        ITEM_COUNT: serverUsers.size()
      }, L10n.Interpolations.Count),
      isDeleteAction: true,
      action: () => this.ServerUsers.deleteUsers(serverUsers.keys())
    });

    dialogInstance.result.then((result: IUserActionResult) => {
      const params: UserActionNotificationParams = {
        users: serverUsers,
        results: result.results,
        errors: result.errors,
        successCode: '11',
      };
      this.userActionNotification.notify(params);
    });

    return dialogInstance.result;
  }

}

Module.instance().service('DeleteUsersFromServerAction', DeleteUsersFromServerAction);
